import { R } from 'core/helpers'

export const getNewValue = (newValue, prevValue) => (R.isFunction(newValue) ? newValue(prevValue) : newValue)

export const removeKey = (obj, key) => {
  const newObj = { ...obj }
  delete newObj[key]
  return newObj
}
